export default "__VITE_ASSET__BwL7peGc__"